export enum UsesTypeName {
    'Residential' = 1,
    'Lodging' = 2,
    'Office' = 3,
    'Commercial' = 4,
    'Civic' = 5,
    'Civic Support' = 6,
    'Educational' = 7,
    'Industrial' = 8,
}
